import { render, staticRenderFns } from "./TheHeaderNotifications.vue?vue&type=template&id=146eac96&scoped=true"
import script from "./TheHeaderNotifications.vue?vue&type=script&lang=js"
export * from "./TheHeaderNotifications.vue?vue&type=script&lang=js"
import style0 from "./TheHeaderNotifications.vue?vue&type=style&index=0&id=146eac96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146eac96",
  null
  
)

export default component.exports